import { render, staticRenderFns } from "./BarChart4.vue?vue&type=template&id=238efcbf&scoped=true"
import script from "./BarChart4.vue?vue&type=script&lang=js"
export * from "./BarChart4.vue?vue&type=script&lang=js"
import style0 from "./BarChart4.vue?vue&type=style&index=0&id=238efcbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238efcbf",
  null
  
)

export default component.exports